<div class="drawer-layout">

  <div class="drawer-content">
    <button mat-button
            class="drawer-action-button"
            [matMenuTriggerFor]="timeFilterMenu"
    >
      <mat-icon>timer</mat-icon>
      @if (sinceHours !== 80) {
        <span class="button-label">Last {{ sinceHours }} hours</span>
      } @else {
        <span class="button-label">Current Storm</span>
      }
      <span><mat-icon class="button-label dropdown-icon">arrow_drop_down</mat-icon></span>
    </button>
    <mat-menu #timeFilterMenu="matMenu">
      @for (item of sinceHoursItems; track item) {
        <button
          mat-menu-item
          (click)="hoursFilterChanged(item)"
          class="drawer-action-menu-item"
        >
          Last {{ item }} hours
        </button>
      }
      @if (configuration?.otherSettings?.stormStatus?.active) {
        <!-- the sinceHours number is irrelevant because it is overridden by cutOff value anyway -->
        <button
          mat-menu-item
          (click)="hoursFilterChanged(80)"
          class="drawer-action-menu-item"
        >
          Current Storm
        </button>
      }
    </mat-menu>
  </div>

  <div class="drawer-content">
    @if (items && items.length > 0) {
      <div cdkDropList
           class="cards-container"
           [cdkDropListData]="items"
           (cdkDropListDropped)="drop($event)"
      >
        @if (existingPinnedItems()) {
          <div class="pinned-items">
            @for (item of items; track $index) {
              @if (item.actionIcon.endsWith('_true')) {
                <app-card-menu-item
                  class="insight-card"
                  cdkDrag
                  [cdkDragData]="item"
                  [item]="item"
                ></app-card-menu-item>
              }
            }
            <div class="divider"></div>
          </div>
        }

        @for (item of items; track $index) {
          @if (item.actionIcon.endsWith('_false')) {
            <app-card-menu-item
              class="insight-card"
              cdkDrag
              [cdkDragData]="item"
              [item]="item"
            ></app-card-menu-item>
          }
        }
      </div>
    }
  </div>
</div>
